import { usePlatformAccessPaywall } from 'features/platformAccess'
import { WIDGET_FEATURE } from 'features/FeatureManager/constants'

const HypePluginLink = () => {

    const { openPlatformAccessPaywall, Paywall } =  usePlatformAccessPaywall()

    return (
        <>
            <span
                onClick={() => openPlatformAccessPaywall(WIDGET_FEATURE)}
            >
                the required plan
            </span>
            <Paywall/>
        </>
    )
}

export default HypePluginLink
